import { useEffect, useState } from 'react';

import { tabletMin } from 'styles/variables';

export const shouldLoadDesktopCalendar = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const { userAgent, platform, maxTouchPoints } = window.navigator;
  const isIPhoneOrIPod = /iPhone|iPod/i.test(userAgent);
  const isAndroidMobile =
    /Android/i.test(userAgent) && /Mobile/i.test(userAgent);
  const isIPad =
    /iPad/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
  const isNarrow = window.matchMedia(`(max-width: ${tabletMin - 1}px)`).matches;
  const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

  return !(
    isIPhoneOrIPod ||
    isAndroidMobile ||
    isIPad ||
    isNarrow ||
    isCoarsePointer
  );
};

const subscribeToMedia = (mediaQuery, handler) => {
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }

  mediaQuery.addListener(handler);

  return () => mediaQuery.removeListener(handler);
};

export const useDesktopCalendarPicker = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const update = () => {
      setIsEnabled(shouldLoadDesktopCalendar());
    };

    update();

    const narrowQuery = window.matchMedia(`(max-width: ${tabletMin - 1}px)`);
    const coarseQuery = window.matchMedia('(pointer: coarse)');
    const unsubscribeNarrow = subscribeToMedia(narrowQuery, update);
    const unsubscribeCoarse = subscribeToMedia(coarseQuery, update);

    return () => {
      unsubscribeNarrow();
      unsubscribeCoarse();
    };
  }, []);

  return isEnabled;
};
